<template>
    <div v-if="isLoaded">
        <div class="content-body">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card">
                        <div
                            class="card-header"
                            style="display: flex; justify-content: space-between"
                        >
                            <h4 class="card-title">
                                Importação de NFe via manifesto
                            </h4>
                            <button
                                type="button"
                                class="btn btn-secondary btn-outline"
                                @click="onImport"
                            >
                                Importar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <ReceberNotasManifestoModal ref="receberNotasManifestoModal" />
        </div>
    </div>
</template>

<script>
import ReceberNotasManifestoModal from "./ReceberNotasManifestoModal";

export default {
    components: {
        ReceberNotasManifestoModal,
    },
    data() {
        return {
            showModal: false,
        };
    },
    computed: {
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            },
        },
    },
    methods: {
        onImport() {
            this.$refs.receberNotasManifestoModal.onImport();
        },
    },
};
</script>
